<template>
  <div class="context">
    <div class="cardheard">
      <div>
        <el-input placeholder="请输入房间名称" v-model="req.parma" />
      </div>

      <el-button type="primary" @click="selectByQuery">查询</el-button>
      <el-button type="primary" @click="clear">清空</el-button>
    </div>
    <template>
      <el-table
        v-model="orders"
        :data="orders"
        style="width: 100%"
        height="80%"
        v-loading="loading"
      >
        <el-table-column type="index" width="50"> </el-table-column>

        <el-table-column label="房间名称">
          <template slot-scope="scope">
            <span>{{ scope.row.homeName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="IP地址">
          <template slot-scope="scope">
            <span>{{ scope.row.ip }}</span>
          </template>
        </el-table-column>


        <el-table-column label="电脑是否可用">
          <template slot-scope="scope">
            <el-switch
            v-model="scope.row.status"
            active-value="0"
            inactive-value="1"
            @change="changeSwtich($event,scope.row)"
          >
          </el-switch>
          </template>
        </el-table-column>

       
      </el-table>

      <div slot="footer" class="dialog-footer">
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="10000"
          >
          </el-pagination>
        </div>
      </div>
    </template>
    <template> </template>
  </div>
</template>

<script>
import store from "@/store/";

export default {
  data() {
    return {
      value1: "0",
      value2: "",
      loading: true,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
        query: {
          sysUserId: 1,
          homeName: "",
        },
      },
      orders: [],
      modelShow: false,
    };
  },
  mounted() {
    this.req.query.sysUserId = this.$store.state.user.user.id;
    this.pushdata();
  },
  methods: {
    changeSwtich(event,row){
      this.loading = true
      console.log(event)
      console.log(row)
      var that = this;
      that.$axios
        .post("/api2/business/changeHomeSwtich", {
          ip:row.ip,
          sysUserId:row.sysUserId,
          status:event
        })
        .then(function (response) {
          that.loading = false;
          that.pushdata()
        });


    },
    reset() {
      this.req.pageIndex = 0;
      this.req.pageCount = 10;
    },
    clear() {
      this.req.parma = "";
      this.req.query.homeName = "";
      this.value1 = "";
      this.reset();
      this.pushdata();
    },
    selectByQuery() {
      this.req.pageIndex = 0;
      this.req.query.homeName = this.req.parma;
      this.pushdata();
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      } else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
      var that = this;
      that.$axios
        .post("/api2/business/showAllHomeUse", this.req)
        .then(function (response) {
          that.loading = false;
          that.orders = response.data.data;
        });
    },
  },
};
</script>
<style scoped></style>
